<template>
  <header class="page-header mb-4">
    <div class="d-flex align-items-baseline">
      <div style="flex-grow: 1">
        <div class="d-flex">
          <b-link class="page-back" @click.prevent="goBack()" v-show="backButtonVisible">
            <b-icon icon="arrow-left-short" />
          </b-link>
          <div>
            <div class="page-title">
              {{ title }}
            </div>
            <div class="page-subtitle" v-show="subtitle">
              <small>{{ subtitle }}</small>
            </div>
          </div>
        </div>
      </div>
      <slot />
    </div>
  </header>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    backTo: {
      type: String,
      default: "",
    },
  },
  computed: {
    backButtonVisible() {
      if (this.backTo != "") {
        return true;
      }

      if (this.$listeners && "back" in this.$listeners) {
        return true;
      }

      return false;
    },
  },
  methods: {
    goBack() {
      const event = new Event("page:back");
      this.$emit("back", event);

      if (event.defaultPrevented) {
        return;
      }

      if (this.backTo != "") {
        this.$router.push(this.backTo);
      }
    },
  },
};
</script>
